import React from 'react'
import Clients from '../components/Clients';

export default function About() {
  return (
    <div className="mx-auto max-w-4xl mt-24">
      <h1 className="text-2xl uppercase font-bold mb-10">About</h1>
      <div className="flex flex-col lg:flex-row space-y-28 lg:space-x-12 lg:space-y-0 mb-24">
        <div className="lg:w-3/4 space-y-10">
          <p>A diverse set of skills and experience in all aspects of film production from development to post-production has given me an elevated understanding of how to achieve the greatest results with the inevitable limtations of budget and time.</p>

          <p>I got my start on low budget films, co-producing and shooting my first feature film starring 
            <a className="font-bold" href="https://www.imdb.com/name/nm0625796/"> Tracy Nelson</a> and 
            <a className="font-bold" href="https://www.imdb.com/name/nm0000616/"> Eric Roberts</a> during my second year of film school in roughly two weeks, during a historic blizzard, on a shoe-string budget. Despite all of this, we managed to sell the film to a major TV network where it aired for many years.</p>

          <p>Since then I've continued shooting many short films, music videos, and commercials as well as the recent award winning feature film, The Mental State. The Mental State collected a number of awards at festivals, including The Catalina Film Festival's Grand Prize and beating out All Quiet on the Western Front for Best Lead Actor in the Newport Beach Film Festival. I had the pleasure of working closely with many talented actors on this project including 
            <a className="font-bold" href="https://www.imdb.com/name/nm5602040/"> Jance Enslin</a>, 
            <a className="font-bold" href="https://www.imdb.com/name/nm0005318/"> Carly Pope</a>, 
            <a className="font-bold" href="https://www.imdb.com/name/nm1451415/"> Alyssa Sutherland</a>, 
            <a className="font-bold" href="https://www.imdb.com/name/nm1034965/"> Bryan Greenberg</a>, 
            <a className="font-bold" href="https://www.imdb.com/name/nm0321591/"> Michael Gladdis</a>, and 
            <a className="font-bold" href="https://www.imdb.com/name/nm0874082/"> Jim True-Frost</a>. I'm currently in the pre-production stages on two other feature films shooting in late 2026 to 2027.</p>

          <p>In between larger projects I also freelance as a colorist and director of photography.</p>
        </div>
        <div className="max-w-lg mx-auto">
          <figure className="relative">
            <img src="/img/bts/tms_bts.webp"></img>
            <figcaption className="absolute left-0 bottom-0 px-2 py-1 bg-black bg-opacity-40 text-white text-sm">photo cred: Peter Mahan</figcaption>
          </figure>
        </div>
      </div>

      <div className="mx-auto">
        <Clients />
      </div>
    
    </div>
  )
}
